import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MatAngularModule } from '../../shared/modules/mat-angular.module';
import { HeaderComponent } from '../../shared/components/header/header.component';

interface Testimonial {
  id: number;
  name: string;
  role: string;
  company: string;
  rating: number;
  quote: string;
  verified: boolean;
  industry: string;
}

@Component({
  selector: 'app-generic-home',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatAngularModule,
    HeaderComponent
  ],
  templateUrl: './generic-home.component.html',
  styleUrl: './generic-home.component.scss'
})
export class GenericHomeComponent implements OnInit, OnDestroy {
  currentIndex = 0;
  private autoRotateInterval: any;

  testimonials: Testimonial[] = [
    {
      id: 1,
      name: 'Sarah Johnson',
      role: 'Chief Marketing Officer',
      company: 'TechCorp Inc.',
      rating: 5,
      quote: 'AI Optima transformed our brand strategy completely. The AI-powered insights helped us increase brand visibility by 150% in just 6 months. The competitive analysis features are game-changing!',
      verified: true,
      industry: 'Technology'
    },
    {
      id: 2,
      name: 'Michael Chen',
      role: 'VP of Marketing',
      company: 'RetailMax',
      rating: 5,
      quote: 'We\'ve tried multiple brand analytics tools, but AI Optima stands out with its accuracy and depth of insights. The real-time tracking and AI recommendations have been invaluable for our campaigns.',
      verified: true,
      industry: 'Retail'
    },
    {
      id: 3,
      name: 'Emily Rodriguez',
      role: 'Brand Director',
      company: 'Global Finance Group',
      rating: 5,
      quote: 'The predictive analytics and sentiment tracking features have given us a competitive edge. We can now anticipate market trends and adjust our strategy proactively. Highly recommended!',
      verified: true,
      industry: 'Finance'
    }
  ];

  constructor() { }

  ngOnInit() {
    this.startAutoRotate();
  }

  ngOnDestroy() {
    this.stopAutoRotate();
  }

  startAutoRotate() {
    this.autoRotateInterval = setInterval(() => {
      this.next();
    }, 5000);
  }

  stopAutoRotate() {
    if (this.autoRotateInterval) {
      clearInterval(this.autoRotateInterval);
    }
  }

  next() {
    this.currentIndex = (this.currentIndex + 1) % this.testimonials.length;
  }

  prev() {
    this.currentIndex = this.currentIndex === 0 ? this.testimonials.length - 1 : this.currentIndex - 1;
  }

  goTo(index: number) {
    this.currentIndex = index;
  }

  getStarArray(rating: number): number[] {
    return Array(rating).fill(0);
  }

}
